/**
 * SubscriptionTypeService
 * Service for SubscriptionType entity operations
 * Route: api/subscriptiontypes
 * Controller: SubscriptionTypesController.cs
 */
import { CrudService } from '../base/CrudService';
export class SubscriptionTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SubscriptionTypeService.DEFAULT_SERVICE_PATH,
            basePath: SubscriptionTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
SubscriptionTypeService.DEFAULT_SERVICE_PATH = 'suppliers';
SubscriptionTypeService.BASE_PATH = 'api/subscriptiontypes';
//# sourceMappingURL=SubscriptionTypeService.js.map